import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Observable, catchError, finalize, tap } from 'rxjs';
import {
  FormData,
  FormDataItem,
  FormElementItem,
} from 'src/app/interfaces/form-data';
import {
  faCheckCircle,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { RequestInfoComponent } from '../request-info/request-info.component';

@Component({
  selector: 'app-request-history-info',
  templateUrl: './request-history-info.component.html',
  styleUrls: ['./request-history-info.component.scss'],
})
export class RequestHistoryInfoComponent
  extends RequestInfoComponent
  implements OnInit
{
  faCheckCircle = faCheckCircle;
  faTimesCircle = faTimesCircle;

  info: any;
  request: any;
  active = 1;

  formData: FormData | undefined;

  displayedColumns: string[] = ['submission', 'step', 'resolvedAt'];

  renewals$: Observable<any> = new Observable<any>();
  transfers$: Observable<any> = new Observable<any>();
  history$: Observable<any> = new Observable<any>();
  deprovionings$: Observable<any> = new Observable<any>();
  checkStatusRequest: boolean = true;

  customFunctions = {
    refresh: (field: FormDataItem, formData: FormData) => {
      console.log('$refresh()', field, formData);
    },
    action: (element: FormElementItem, formData: FormData) => {
      console.log('$action()', element, formData);
    },
  };

  ngOnInit(): void {
    this.spinnerService.open();
    this.requestService
      .getRequest(this.info.id)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          this.spinnerService.close();
          return this.errorService.handlerErrorSubscribe(error);
        })
      )
      .subscribe((data: any) => {
        this.request = data;
        this.formData = data.form;
        this.spinnerService.close();
      });
    this.checkStatusRequest = !this.info.status.some(
      (status: any) => !status.status || status.status === ''
    );
    this.history$ = this.requestService.getHistory(this.info.id).pipe(
      tap(() => this.spinnerService.open()),
      catchError((error: HttpErrorResponse) => {
        return this.errorService.handlerErrorSubscribe(error);
      }),
      finalize(() => this.spinnerService.close())
    );
    if (this.checkStatusRequest) {
      this.renewals$ = this.requestService.getRenew(this.info.id).pipe(
        tap(() => this.spinnerService.open()),
        catchError((error: HttpErrorResponse) => {
          return this.errorService.handlerErrorSubscribe(error);
        }),
        finalize(() => this.spinnerService.close())
      );
      this.transfers$ = this.requestService.getTransfer(this.info.id).pipe(
        tap(() => this.spinnerService.open()),
        catchError((error: HttpErrorResponse) => {
          return this.errorService.handlerErrorSubscribe(error);
        }),
        finalize(() => this.spinnerService.close())
      );
      this.deprovionings$ = this.requestService
        .getDeprovisioning(this.info.id)
        .pipe(
          tap(() => this.spinnerService.open()),
          catchError((error: HttpErrorResponse) => {
            return this.errorService.handlerErrorSubscribe(error);
          }),
          finalize(() => this.spinnerService.close())
        );
    }
  }
}
